import { getEnvVars } from '../../../utils';

const { NO_JIRA_TICKET_IN_BRANCH_NAME, JIRA_TICKET_ID } = getEnvVars();

export const getEphemeralHeaders = (): HeadersInit => {
  if (NO_JIRA_TICKET_IN_BRANCH_NAME === 'true') return {};

  if (JIRA_TICKET_ID?.length === 0) return {};

  return { jiraid: JIRA_TICKET_ID };
};
